import {Component, computed, DestroyRef, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {AuthService} from '@auth0/auth0-angular';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Dashboard} from '../../core/domain/dto/dashboard.dto';
import {DashboardWebservice} from '../../core/services/dashboard-webservice';
import {ApplicationCard} from '../../components/dashboard/application-card/application-card';
import {LinkCard} from '../../components/dashboard/link-card/link-card';
import {Header} from '../../components/header/header';
import {Footer} from '../../components/footer/footer';
import {ApplicationLinkPipe} from '../../core/pipes/application-link-pipe';

@Component({
  selector: 'app-dashboard-page',
  imports: [
    ApplicationCard,
    LinkCard,
    Header,
    Footer,
    ApplicationLinkPipe
  ],
  templateUrl: './dashboard-page.html',
  styleUrl: './dashboard-page.scss'
})
export class DashboardPage implements OnInit {
  private readonly authService: AuthService = inject(AuthService);
  private readonly dashboardService: DashboardWebservice = inject(DashboardWebservice);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  protected readonly dashboardData: WritableSignal<Dashboard | undefined> = signal(undefined)

  public readonly unAttachedLinks = computed(() => {
    return this.dashboardData()?.links?.filter(link => !link.app) || [];
  })

  public readonly userName = computed(() => {
    return `Bonjour ${this.dashboardData()?.givenName} ${this.dashboardData()?.familyName} !`;
  })

  ngOnInit() {
    this.authService.user$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.dashboardService.getDashboardData()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(dashboard => {
            this.dashboardData.set(dashboard);
          })
      })
  }
}
